<template>
    <div class="purchase-file">
        <div class="purchase-file__meta">
            <CompassColoredIcon
                icon="document"
                size="large"
                :color="error ? 'coral' : 'light-blue'"
            />
            <div class="purchase-file__text">
                <span class="purchase-file__name typographies-paragraph-medium-regular">
                    {{ file.name }}
                </span>
                <span
                    v-if="error"
                    class="purchase-file__error typographies-paragraph-small-regular"
                >
                    {{ error }}
                </span>
                <span
                    v-else
                    class="purchase-file__size typographies-paragraph-small-regular"
                >
                    {{ formattedSize }}
                </span>
            </div>
        </div>

        <CompassIconButton
            v-if="showRemove && !disabled"
            icon="close"
            size="small"
            @click="$emit('remove', file.id)"
        />
    </div>
</template>

<script>
export default {
    name: 'PurchaseFileItem',
    props: {
        file: {
            type: Object,
            required: true,
        },
        error: {
            type: String,
            default: '',
            required: false,
        },
        showRemove: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        formattedSize() {
            const size = this.file?.size || 0;
            const kilobyte = 1024;
            return `${Math.round(size / kilobyte)}KB`;
        },
    },
};
</script>

<style lang="scss" scoped>
.purchase-file {
    border-radius: var(--spacing-1);
    padding: var(--spacing-2);
    display: flex;
    box-shadow: var(--elevation-1);
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-2);

    &__meta {
        display: flex;
        align-items: center;
        gap: var(--spacing-2);
    }

    &__text {
        display: flex;
        flex-direction: column;
    }

    &__name {
        color: var(--colors-common-text-standard-default);
    }

    &__size {
        color: var(--colors-common-text-subtle-default);
    }
    &__error {
        color: var(--colors-common-text-alert-default);
    }
}
</style>
